graph.$inject = ['$http', '$q', 'configuration']

export default function graph($http, $q, config) {
  var endPoint = config.apiEndPoint
  return {
    ////////////////////////
    // Domain info routes //
    ////////////////////////
    saveDomainInfo: function(domainInfo) {
      var deferred = $q.defer()
      $http.post(endPoint + '/domain_info/' + domainInfo.domain_uuid, domainInfo).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.reject(response.data)
        }
      )
      return deferred.promise
    },

    getDomains: function() {
      var deferred = $q.defer()
      $http.get(endPoint + '/graph/domains').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.resolve({
            status: 'error',
            message: 'Unknown error'
          })
        }
      )
      return deferred.promise
    },
    getDomain: function(domainUuid) {
      var deferred = $q.defer()
      $http.get(endPoint + '/graph/domain/' + domainUuid).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.resolve({
            status: 'error',
            message: 'Error: ' + response.data
          })
        }
      )
      return deferred.promise
    },
    updateDomain: function(domainUuid, data) {
      var deferred = $q.defer()
      $http.put(endPoint + '/graph/domain/' + domainUuid, data).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          console.log('updateDomain error')
          console.log(response)
          deferred.reject(response.data)
        }
      )
      return deferred.promise
    },
    getDomainDetail: function(domainUuid) {
      var deferred = $q.defer()
      $http.get(endPoint + '/graph/domain/' + domainUuid + '/detail').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.resolve({
            status: 'error',
            message: 'Error: ' + response.data
          })
        }
      )
      return deferred.promise
    },
    createDomain: function(name) {
      var deferred = $q.defer()
      $http.post(endPoint + '/graph/domain', { name: name }).then(
        function(response) {
          console.log('createDomain success')
          console.log(response)
          deferred.resolve(response.data)
        },
        function(response) {
          console.log('createDomain error')
          console.log(response)
          deferred.resolve({
            status: 'error',
            message: 'Unknown error creating domain'
          })
        }
      )
      return deferred.promise
    },
    getDomainSchools: function(domainUuid) {
      var deferred = $q.defer()
      $http.get(endPoint + '/graph/domain/' + domainUuid + '/schools').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.resolve({
            status: 'error',
            message: 'Error: ' + response.data
          })
        }
      )
      return deferred.promise
    },
    getDomainSchoolAdmins: function(domainUuid) {
      var deferred = $q.defer()
      $http.get(endPoint + '/graph/domain/' + domainUuid + '/school_admins').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.reject(response.data)
        }
      )

      return deferred.promise
    },
    getSchoolUsers: function(schoolUuid) {
      var deferred = $q.defer()
      $http.get(endPoint + '/graph/school/' + schoolUuid + '/users').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.reject(response.data)
        }
      )

      return deferred.promise
    },
    getDomainUsers: function(domainUuid) {
      var deferred = $q.defer()
      $http.get(endPoint + '/graph/domain/' + domainUuid + '/users').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.resolve({
            status: 'error',
            message: 'Error: ' + response.data
          })
        }
      )
      return deferred.promise
    },
    // schoolUuid is optional
    getDomainUserLicenses: function(domainUuid, schoolUuid, subgroupUuid=null) {
      var deferred = $q.defer()
      var url = endPoint + '/domain/' + domainUuid + '/user_licenses'
      if (schoolUuid) {
        url += '?school_uuid=' + schoolUuid
      }
      $http.get(url).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.reject({
            status: 'error',
            message: 'Error: ' + response.data
          })
        }
      )
      return deferred.promise
    },
    createSchool: function(domainUuid, school) {
      var deferred = $q.defer()
      $http.post(endPoint + '/graph/domain/' + domainUuid + '/school', school).then(
        function(response) {
          console.log('createSchool success')
          console.log(response)
          deferred.resolve(response.data)
        },
        function(response) {
          console.log('createSchool error')
          console.log(response)
          deferred.resolve({
            status: 'error',
            message: 'Unknown error creating domain'
          })
        }
      )
      return deferred.promise
    },
    updateSchool: function(schoolUuid, data) {
      var deferred = $q.defer()
      $http.put(endPoint + '/graph/school/' + schoolUuid, data).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          console.log('updateSchool error')
          console.log(response)
          deferred.reject(response.data)
        }
      )
      return deferred.promise
    },
    getAdmins: function(entityUuid, entityType) {
      var deferred = $q.defer()
      if (entityType !== 'domain' && entityType !== 'school') {
        deferred.reject('Invalid entity type: ' + entityType)
        return deferred.promise
      }
      $http.get(endPoint + '/graph/' + entityType + '/' + entityUuid + '/admins').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.reject(response.data)
        }
      )
      return deferred.promise
    },
    updateAdminship: function(entityUuid, entityType, userUuid, giveAdminship) {
      var deferred = $q.defer()
      if (entityType !== 'domain' && entityType !== 'school') {
        deferred.reject('Invalid entity type: ' + entityType)
      } else if (!entityUuid) {
        deferred.reject('Entity UUID not specified')
      } else if (!userUuid) {
        deferred.reject('User UUID not specified')
      } else {
        var adminshipUrlFragment = ''
        if (giveAdminship) {
          adminshipUrlFragment = 'add_adminship'
        } else {
          adminshipUrlFragment = 'remove_adminship'
        }
        var url =
          endPoint +
          '/graph/' +
          entityType +
          '/' +
          entityUuid +
          '/' +
          adminshipUrlFragment +
          '/' +
          userUuid
        $http.post(url, null).then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject(response.data)
          }
        )
      }

      return deferred.promise
    },
    toggleILPAccess: function(userUuids, { set }) {
      var data = {
        uuids: userUuids,
        payload: {}
      }
      if (set) {
        data.payload.ilp_access = true
      }
      if (set === false) {
        data.payload.ilp_access = false
      }
      return $http.put(`${endPoint}/graph/batch`, data).then(
        response => response.data,
        err => {
          throw err.data
        }
      )
    },
    deleteEntity: function(uuid) {
      return $http.delete(`${endPoint}/graph/${uuid}/delete`).then(
        resp => resp.data,
        err => {
          throw err.data
        }
      )
    }
  }
}
